import { memo, useState, useContext, useEffect } from 'react';

import { useForm } from 'react-hook-form';

import Breadcrumb from '@/components/atoms/breadcrumb/breadcrumb';
import Input from '@/components/atoms/input/input';
import Loader from '@/components/atoms/loader/loader';
import Modal from '@/components/atoms/modal/modal';
import Select from '@/components/atoms/select/select';
import UseDocumentType from '@/hooks/UseDocumentType';
import { getCesdePaymentReference } from '@/services/certificate-services';

import CloseBtn from '../../../assets/images/icons/close_black_24dp.svg';
import GlobalContext from '../../../contexts/globalContext';
import FormAndNoteTemplate from '../form-and-note-template/formAndNoteTemplate';

import './searchReference.scss';
import PaymentReference from '../payment-reference-cesde/paymentReference';

import Button from '../../atoms/button/button';

const MemoSearchReference = ({ contentInfo }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [data, setData] = useState(null);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTypePerson, setSelectedTypePerson] = useState('self');
  const [personalCredits, setPersonalCredits] = useState<any>(null);
  const [selectedPersonalCredit, setSelectedPersonalCredit] = useState<any>([]);
  const { gigyaContext } = useContext(GlobalContext);
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
    resetField,
  } = useForm();

  const formInfo = contentInfo.referencias[1].referencias;
  const radioReferences = contentInfo.referencias[4].referencias[0];

  const onSubmitForm = async (data) => {
    setIsLoading(true);
    const { docNumber, documentType, method } = data;
    if (method === 'self') {
      window.location.href =
        window.location.origin +
        (window?.location.hostname === 'localhost'
          ? '/pagos/pago-credito-personas'
          : '/portal-servicios/pagos/pago-credito-personas');
      setIsLoading(false);
    }

    if (!method || method === 'other') {
      const docType = UseDocumentType(documentType).tipoDocumentoLegdos;
      const response = await getCesdePaymentReference(docType, docNumber);

      if (response.status === 200 && response.data.status === 200) {
        setData(response.data.data);
        setIsLoading(false);
        setCurrentStep(1);
      } else {
        setShowErrorModal(true);
      }
    }
  };

  const closeModal = () => {
    setShowErrorModal(false);
    setIsLoading(false);
  };

  const getLoggedInfoData = async () => {
    const docType = UseDocumentType(gigyaContext?.gigyaAccount?.data.docType).tipoDocumentoLegdos;
    const docNumber = gigyaContext?.gigyaAccount?.data.docNumber;

    const response = await getCesdePaymentReference(docType, docNumber);

    try {
      if (response.status === 200 && response.data.status === 200) {
        setPersonalCredits(response.data.data);
        setIsLoading(false);
      }

      if (response.status === 200 && response.data.status === 400) {
        setPersonalCredits([]);
      }
    } catch (error) {
      console.log(error);
      setShowErrorModal(true);
    }
  };

  const addCreditData = (info) => {
    const creditInfo = info;
    const creditList = [...personalCredits];
    const personalCreditSelected: any = [];
    const filter = creditList.findIndex((el: any) => {
      return el.referenciaPago === creditInfo.referenciaPago;
    });

    if (filter !== -1) {
      personalCreditSelected.push(creditList[filter]);
    }
    setSelectedPersonalCredit(personalCreditSelected);
  };

  const validateIfIsSelected = (info) => {
    const creditInfo = info;
    const creditList = [...selectedPersonalCredit];
    const filter = creditList.findIndex((el: any) => {
      return el.referenciaPago === creditInfo.referenciaPago;
    });
    return filter !== -1;
  };

  useEffect(() => {
    if (gigyaContext && gigyaContext.gigyaAccount) {
      setSelectedTypePerson('self');
      getLoggedInfoData();
    } else {
      setSelectedTypePerson('other');
    }
  }, []);

  return (
    <div className="o-search-reference-content">
      <div className="o-search-reference-content__header">
        <div className="o-search-reference-content__header__migaDePan">
          <Breadcrumb content={contentInfo.migaDePan} />
        </div>
        <div className="o-search-reference-content__header__title">
          <h1 className="o-search-reference-content__header__title__h1">{contentInfo.nombre}</h1>
          <h2 className="o-search-reference-content__header__title__h2">{contentInfo.subtitulo}</h2>
        </div>
      </div>
      {currentStep === 0 ? (
        <FormAndNoteTemplate
          notePosition="left"
          note={{
            image: contentInfo.referencias[0].imagen[0],
            title: contentInfo.referencias[0].nombre,
            content: contentInfo.referencias[0].descripcion,
          }}
          secondTitle={contentInfo.referencias[1].nombre}
          secondSubtitle={contentInfo.referencias[1].subtitulo}
          buttonCopy={
            selectedTypePerson === 'self' ? 'Ir a Pagar' : contentInfo.referencias[1].boton[0].copy
          }
          loader={isLoading}
          subRoute="referencia-pago-cesde"
          buttonEvent={() => {
            handleSubmit(onSubmitForm)();
          }}
          disableButton={
            selectedTypePerson === 'self' ? !(selectedPersonalCredit.length > 0) : false
          }
        >
          {gigyaContext && gigyaContext.gigyaAccount && (
            <>
              <span className="o-search-reference-content__form-methods__title">
                {radioReferences.nombreEmpresa}
              </span>
              <div className="o-search-reference-content__form-methods">
                <div className="o-search-reference-content__form-method-item">
                  <div
                    className="o-search-reference-content__form-method-button"
                    onClick={() => {
                      setSelectedTypePerson('self');
                      resetField('documentType');
                      resetField('docNumber');
                      setValue('docNumber', '');
                    }}
                  >
                    <input
                      type="radio"
                      id="radioSelf"
                      value="self"
                      defaultChecked
                      {...register('method', {
                        required: true,
                      })}
                    />
                    <div className="o-search-reference-content__form-radio-button">
                      <div className="o-search-reference-content__form-radio-button-inner" />
                    </div>
                  </div>
                  <label
                    htmlFor="radioSelf"
                    className={selectedTypePerson === 'self' ? '__active' : ''}
                  >
                    {radioReferences.lista[0]}
                  </label>
                </div>
                <div className="o-search-reference-content__form-method-item">
                  <div
                    className="o-search-reference-content__form-method-button"
                    onClick={() => {
                      setSelectedTypePerson('other');
                      setSelectedPersonalCredit([]);
                    }}
                  >
                    <input
                      type="radio"
                      id="radioOther"
                      value="other"
                      {...register('method', {
                        required: true,
                      })}
                    />
                    <div className="o-search-reference-content__form-radio-button">
                      <div className="o-search-reference-content__form-radio-button-inner" />
                    </div>
                  </div>
                  <label
                    htmlFor="radioOther"
                    className={selectedTypePerson === 'other' ? '__active' : ''}
                  >
                    {radioReferences.lista[1]}
                  </label>
                </div>
              </div>
              {selectedTypePerson === 'self' && (
                <>
                  {personalCredits ? (
                    personalCredits.length > 0 ? (
                      <>
                        <div className="o-search-reference-content__form__credits__title">
                          <h3>{contentInfo.referencias[4].nombreEmpresa}</h3>
                          <p>{contentInfo.referencias[4].spanMagenta} </p>
                        </div>
                        <ul className="o-search-reference-content__form__credits__list">
                          {personalCredits.map((info, index) => {
                            return (
                              <li
                                className={`o-search-reference-content__form__credits__list__credit ${
                                  validateIfIsSelected(info) ? '__active' : ''
                                }`}
                                key={`o-search-reference-content__form__credits__list__credit-${index}`}
                                onClick={() => {
                                  addCreditData(info);
                                }}
                              >
                                <div className="o-search-reference-content__form__credits__list__credit__left">
                                  <div className="o-search-reference-content__form__credits__list__credit__left__radius">
                                    <div className="o-search-reference-content__form__credits__list__credit__left__radius__inner" />
                                  </div>
                                </div>
                                <div className="o-search-reference-content__form__credits__list__credit__right">
                                  <div className="o-search-reference-content__form__credits__list__credit__right__item">
                                    <span>
                                      <b>Credito de estudio</b>
                                    </span>
                                    <span>{`Obligación No. ${info.referenciaPago}`}</span>
                                  </div>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      </>
                    ) : (
                      <div className="o-search-reference-content__form__credits__none">
                        <img
                          src={radioReferences.imagen[0].file.url}
                          alt="check image"
                          title="check image"
                        />
                        <p>Actualmente no tienes ninguna obligación pendiente.</p>
                      </div>
                    )
                  ) : (
                    <div className="o-search-reference-content__form__credits__loader">
                      <Loader size="__medium" />
                    </div>
                  )}
                </>
              )}
            </>
          )}
          {(!gigyaContext || !gigyaContext.gigyaAccount || selectedTypePerson === 'other') && (
            <div className="o-search-reference-content__inputs">
              {formInfo[0] && formInfo[0].nombre && (
                <div className="m-request-form-shift__input">
                  <Select
                    label={formInfo[0].nombre ? formInfo[0].nombre : 'Tipo de documento'}
                    name="documentType"
                    id="documentType"
                    register={register}
                    options={
                      formInfo[0].listaJson
                        ? formInfo[0].listaJson
                        : [
                            {
                              name: 'Selecciona un tipo de documento',
                              value: '',
                            },
                          ]
                    }
                    setValue={setValue}
                    square
                    validationRules={{
                      required: {
                        value: true,
                        message: 'Campo requerido',
                      },
                    }}
                    defaultValue={{
                      name: 'Selecciona un tipo de documento',
                      value: '',
                    }}
                    error={errors.documentType}
                    required
                  />
                </div>
              )}
              {formInfo[1] && formInfo[1].nombre && (
                <div className="m-request-form-shift__input">
                  <Input
                    label={formInfo[1].nombre ? formInfo[1].nombre : 'Número de documento'}
                    name="docNumber"
                    id="docNumber"
                    maxLength="25"
                    type="number"
                    square
                    placeholder={
                      formInfo[1].subtitulo
                        ? formInfo[1].subtitulo
                        : 'Escribe tu número de documento'
                    }
                    register={register}
                    validationRules={{
                      required: {
                        value: true,
                        message: 'Campo requerido',
                      },
                      pattern: {
                        value: /^[{0-9}]+$/,
                        message: 'No se permiten caracteres especiales',
                      },
                      maxLength: {
                        value: 25,
                        message: 'El documento no debe superar los 25 dígitos',
                      },
                      minLength: {
                        value: 5,
                        message: 'El documento debe tener al menos 5 dígitos',
                      },
                    }}
                    setValue={setValue}
                    required
                    error={errors.docNumber}
                  />
                </div>
              )}
            </div>
          )}
        </FormAndNoteTemplate>
      ) : (
        <PaymentReference data={data} contentInfo={contentInfo} setCurrentStep={setCurrentStep} />
      )}
      {showErrorModal && (
        <Modal open={showErrorModal} onClose={closeModal}>
          <div className="o-search-reference-content__Message">
            <div className="o-search-reference-content__Message__Close">
              <span onClick={closeModal}>
                <img className="image-tutorial-image" src={CloseBtn} alt="Close" title="Close" />
              </span>
            </div>
            <div className="o-search-reference-content__Message__Image">
              <img
                className="image-tutorial-image"
                src={contentInfo.modal[0].imagen[0].file.url}
                alt="Alert"
                title="Alert"
              />
            </div>
            <div className="o-search-reference-content__Message__InformationCont">
              <div className="o-search-reference-content__Message__InformationCont__Info">
                <p className="o-search-reference-content__Message__InformationCont__Info__Message1">
                  {contentInfo.modal[0].spanMagenta}
                </p>
                <p className="o-search-reference-content__Message__InformationCont__Info__Message2">
                  {contentInfo.modal[0].subtitulo}
                </p>
                <p className="o-search-reference-content__Message__InformationCont__Info__Message3">
                  {contentInfo.modal[0].nombre}
                </p>
              </div>
            </div>
            <div className="o-search-reference-content__Message__TryAgain">
              <Button
                type="button"
                classname="o-search-reference-content__Message__TryAgain__TryAgainButton modal"
                text={contentInfo.modal[0].boton[0].copy}
                isDisabled={false}
                onClickAction={closeModal}
              />
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

const SearchReference = memo(MemoSearchReference);

export default SearchReference;
